import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaptureMathComponent } from './capture-math/capture-math.component';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    CaptureMathComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  exports: [
    CaptureMathComponent
  ]
})
export class WidgetMathModule { }
